import { useEffect, useState } from "react";
import { setHeaderDark } from "@/lib/headerTheme";

export const HEADER_H = 76;

/**
 * Tracks where the hero is relative to the top bar: the bar goes dark while the hero is beneath it,
 * and `passed` turns true once the hero has scrolled out (so a sticky info rail can take over).
 */
export const useHeroScroll = (ref, enabled = true, dark = true) => {
  const [passed, setPassed] = useState(false);
  useEffect(() => {
    if (!enabled) return undefined;
    let raf = 0;
    const update = () => {
      raf = 0;
      const el = ref.current;
      if (!el) return;
      const bottom = el.getBoundingClientRect().bottom;
      setHeaderDark(dark && bottom > HEADER_H);
      setPassed(bottom <= HEADER_H);
    };
    const on = () => { if (!raf) raf = window.requestAnimationFrame(update); };
    update();
    window.addEventListener("scroll", on, { passive: true });
    window.addEventListener("resize", on);
    return () => { window.removeEventListener("scroll", on); window.removeEventListener("resize", on); if (raf) window.cancelAnimationFrame(raf); setHeaderDark(false); };
  }, [ref, enabled, dark]);
  return passed;
};
